export const administration = {
    route: 'Administration',
    allHomesLabel: 'All homes',
    allUsersLabel: 'All users',
    sureToDeleteUserContent: 'Deleted user name is: ',
    sureToUndeleteUserContent: 'Undeleted user name is: ',
    invitationPending: 'Invitation pending'
};
